

import { connect } from 'react-redux'
import React, { Component } from 'react'
import printIcon from '../images/print-icon.png';

class PrintButton extends Component {
    render(){
        if(this.props.deviceType === "Mobile" || this.props.deviceType === "Tablet"){
            return <></>;
        } else{
            return (
                <div className="printButton">
                    <button
                        class={"btn btn-light"}
                        onClick={() => window.print()}
                    >
                        <img src={printIcon} width="18px"/>&nbsp;
                        {this.props.strings.PRINT_BUTTON}
                    </button>
                </div>
            );
        }
    }
}


const mapStateToProps = (state, ownProps) => {
    return {
        strings: state.language.strings,
        deviceType: state.api.deviceType
    }
}

export default connect(mapStateToProps)(PrintButton)
